import React, { Component } from 'react'
import PropTypes from 'prop-types'
import WizardFormFirstPage from '../common/WizardFormFirstPage'
import WizardFormSecondPage from '../common/WizardFormSecondPage'
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import moment from "moment";
import { createHashHistory } from 'history';
import {
  NewBreadcrumb as BreadcrumbComponent
}                        from '../../../../components';

import { createEmailManager, getEmailManagerDetail, editEmailManager, emailTemplate } from '../../../../redux/actions/emailManagerActions';
import {renderAlert,clearAlert} from '../../../../redux/actions/alertsActions';

let campaignID, dealID = [];
class OfferMail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: ['Home', 'Email Manager', 'Offer Contest'],
      links: ["home",'email-manager/overview','email-manager/offeremail'],
      page: 1,
      fetchData: '',
      campaignName: '',
      subject: '',
      customEmailContent: '',
      show: false,
      alertMessage:'',
      title: 'Offer Contest', 
    }

    this.nextPage = this.nextPage.bind(this)
    this.previousPage = this.previousPage.bind(this)
    this.setData = this.setData.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handlePageChange = () =>{
    dealID[0] = this.props.match.params.dealID ? this.props.match.params.dealID : '';
    if(dealID[0] !== ''){
      this.props.emailTemplate({templateName: 'emailManager', site_id: localStorage.getItem("siteID")});
    }
    campaignID = this.props.match.params.campaignID ? this.props.match.params.campaignID : '';
    if (campaignID !== '')
    {
      // isLoading="true";
      this.props.getEmailManagerDetail(campaignID, localStorage.getItem("siteID")); 
    }
  }

  componentWillMount(){
    this.props.clearAlert ();
    this.handleDismiss();
    this.handlePageChange();
  }

  componentWillReceiveProps(nextProps){
    if(this.props.template != nextProps.template){
      if(nextProps.template){
        this.setState({customEmailContent: nextProps.template.data.content});
      }
    }
    if(this.props.emailData != nextProps.emailData){
      if(nextProps.emailData){
        let data = nextProps.emailData.data;
        this.setState({
          campaignName: data.campaignName,
          subject: data.subject,
          customEmailContent: data.customEmailContent,
        });
      }
    }
    
    if(this.props.emailUpdateStatus !== nextProps.emailUpdateStatus){
        if(nextProps.emailUpdateStatus){
          this.props.clearAlert ();
          this.handleShow();
          this.props.renderAlert('success', nextProps.emailUpdateStatus.message);
          this.setState({page: 1})
          window.scrollTo(0, 0);
        }
    }
    if(this.props.emailStatus !== nextProps.emailStatus){
        if(nextProps.emailStatus){
          this.props.clearAlert ();
          this.handleShow();
          this.props.renderAlert('success', nextProps.emailStatus.message);
          this.setState({page: 1})
          this.state.emailType = '';
          this.state.campaignName = '';
          this.state.subject = '';
          
          this.state.scheduleOn = '';
          this.state.cities = '';
          this.state.subscriberType = '';
          this.state.subscriberStartDate = '';
          this.state.subscriberEndDate = '';
          this.state.filterPurchase = '';
          this.state.catID = '';
          window.scrollTo(0, 0);
        }
    }

    if(this.props.error !== nextProps.error){
        if(nextProps.error){
          // this.setState({submitValue:'Save', disabled:''})
          this.props.clearAlert ();
          this.handleShow();
          this.props.renderAlert('warning',nextProps.error);
          window.scrollTo(0, 0);
        }
    } 
    if(nextProps.message){
      this.handleShow();
      this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType})
      window.scrollTo(0, 0);
    }

  }
  nextPage() {
    this.setState({ page: this.state.page + 1 })
  }

  previousPage() {
    this.setState({ page: this.state.page - 1 })
  }

  setData = (data) => {
    this.setState(data);
  }

  saveData = (data) => {
    this.setState(data);
    if(campaignID == ''){
      const saveData = {
        emailType: 'offerContest',
        dealID: dealID,
        campaignName: this.state.campaignName,
        subject: this.state.subject,
        customEmailContent: this.state.customEmailContent,
        scheduleOn: (data.scheduleDateTime) ? moment(data.scheduleDateTime).format('YYYY-MM-DD HH:mm:ss') : '',
        cities: data.cityID,
        subscriberType: (data.startDateValue == 'all') ? 'all' : 'NotAll',
        subscriberStartDate: (data.startDateRange[0]) ? moment(data.startDateRange[0]).format('YYYY-MM-DD HH:mm:ss') : '',
        subscriberEndDate: (data.startDateRange[1]) ? moment(data.startDateRange[1]).format('YYYY-MM-DD HH:mm:ss') : '',
        filterPurchase: (data.purchases == 'category' || data.purchases == 'merchant' || data.purchases == 'not_purchase') ? 'NotAll' : data.purchases,
        catID: data.catID,
        merchantID: data.merchantID,
        importedFiles: data.subscriberList,
        site_id: localStorage.getItem("siteID")
      }

      this.props.createEmailManager(saveData);
    }else{
      const updateData = {
        id: campaignID,
        dealID: dealID,
        emailType: 'offerContest',
        campaignName: this.state.campaignName,
        subject: this.state.subject,
        customEmailContent: this.state.customEmailContent,
        scheduleOn: (data.scheduleDateTime) ? moment(data.scheduleDateTime).format('YYYY-MM-DD HH:mm:ss') : '',
        cities: data.cityID,
        subscriberType: (data.startDateValue == 'all') ? 'all' : 'NotAll',
        subscriberStartDate: (data.startDateRange[0]) ? moment(data.startDateRange[0]).format('YYYY-MM-DD HH:mm:ss') : '',
        subscriberEndDate: (data.startDateRange[1]) ? moment(data.startDateRange[1]).format('YYYY-MM-DD HH:mm:ss') : '',
        filterPurchase: (data.purchases == 'category' || data.purchases == 'merchant' || data.purchases == 'not_purchase') ? 'NotAll' : data.purchases,
        catID: data.catID,
        merchantID: data.merchantID,
        importedFiles: data.subscriberList,
        site_id: localStorage.getItem("siteID")
      }

      
      this.props.editEmailManager(updateData);
      
    }    
  }

  render() {
    const { onSubmit } = this.props
    const { page } = this.state
    let showStatus = false;
    if(campaignID != ''){
      showStatus = (this.state.campaignName) ? true : false;
    }else{
      showStatus = (this.state.customEmailContent) ? true : false;
    }
    return (
      <div className="col-lg-12 add-sub-admin">
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            {this.state.show && this.state.alertMessage !=='' &&        
              <div className="col-lg-12">
                <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                  <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                </Alert>
              </div>
            }
          </div>
        </div>
        {(dealID[0] != '') ?
        <div>
          {(page === 1 && showStatus) && 
            <WizardFormFirstPage 
              onSubmit={this.nextPage} 
              onSubmitData={this.setData}
              dataValue={this.state}
            />
          }
        </div>
        :
        <div>
          {(page === 1) && 
            <WizardFormFirstPage 
              onSubmit={this.nextPage} 
              onSubmitData={this.setData}
              dataValue={this.state}
            />
          }
        </div>
        }
        
        {page === 2 && (
          <WizardFormSecondPage
            previousPage={this.previousPage}
            onSave={this.saveData}
            onPrevData={this.setData}
            data={this.state}
          />
        )}
      </div>
    )
  }
}

OfferMail.propTypes = {
  // onSubmit: PropTypes.func.isRequired
}

const mapStateToProps = (state,ownProps) => {
    return {
      error: state.emailManagerReducer.error,
      emailStatus:  state.emailManagerReducer.emailStatus,
      emailData: state.emailManagerReducer.emailData,
      alertType: state.alertsReducer.alertType,
      message: state.alertsReducer.message,
      template: state.emailManagerReducer.template,
      emailUpdateStatus: state.emailManagerReducer.emailUpdateStatus,
    };
};
export default compose(
  withRouter, 
  connect(mapStateToProps, {createEmailManager, getEmailManagerDetail, editEmailManager, renderAlert, clearAlert, emailTemplate})
)(OfferMail);


// WEBPACK FOOTER //
// ./src/app/views/admin/EmailManager/common/OfferMail.js